import { Injectable, inject } from '@angular/core'
import { Action, Store, select } from '@ngrx/store'

import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'
import * as ProjectorTemplatesSelectors from './projector-templates.selectors'

@Injectable({
  providedIn: 'root',
})
export class ProjectorTemplatesFacade implements GbBaseFacade {
  private readonly store = inject(Store)

  projectorTemplatesLoaded$ = this.store.pipe(select(ProjectorTemplatesSelectors.selectProjectorTemplatesLoaded))
  projectorTemplatesEditCreateLoaded$ = this.store.pipe(
    select(ProjectorTemplatesSelectors.selectProjectorTemplatesEditCreateLoaded),
  )
  allProjectorTemplates$ = this.store.pipe(select(ProjectorTemplatesSelectors.selectAllProjectorTemplatesList))
  selectedProjectorTemplate$ = this.store.pipe(select(ProjectorTemplatesSelectors.selectSelectedProjectorTemplate))
  editCreateLoaded$ = this.store.pipe(select(ProjectorTemplatesSelectors.selectProjectorTemplatesEditCreateLoaded))
  applyTemplateLoaded$ = this.store.pipe(select(ProjectorTemplatesSelectors.selectApplyTemplateLoaded))

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
